// store/middleware/complexOrdersCacheMiddleware.ts
import { Middleware } from "@reduxjs/toolkit";
import { saveToStorage } from "../../common/utils/functions/localStorage";
import { getCacheVersion } from "../../config/runtimeConfig";

export const complexOrdersCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type === "complexOrderList/setComplexOrders") {
      const orders = store.getState().complexOrderList.data;

      if (orders) {
        try {
          const version = getCacheVersion();
          const CACHE_KEY = `complexOrders_v${version}`;
          saveToStorage(CACHE_KEY, orders);
        } catch (error) {
          console.error("Ошибка сохранения кэша комплексных заказов:", error);
        }
      }
    }

    return result;
  };
